import { LoginRequest } from '../../types/requests/auth'
import { apiService } from './apiService'

class AuthService {
  private endpoint = '/auth'

  async login(request: LoginRequest) {
    const response = await apiService.post(`${this.endpoint}/login`, request)

    return response.data
  }

  async logout() {
    const response = await apiService.post(`${this.endpoint}/logout`, {})

    return response.data
  }
}

const authService = new AuthService()

export default authService
